import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

/*
  Generated class for the SubjectProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ResultProvider {

    url: string = 'http://qbankapiv2.showmywork.in/student/';

    constructor(public http: HttpClient) {
        console.log('Hello ResultProvider Provider');
    }

    addResult(obj) {
        return this.http.post(this.url + 'addResult', obj).map(res => res);
    }

    getCareer() {
        return this.http.get(this.url + 'getCareer').map(res => res);
    }

    getResults(career_id) {
        return this.http.get(this.url + 'getResults/' + career_id).map(res => res);
    }
}



// WEBPACK FOOTER //
// ./src/providers/result.ts